import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';

import TimeErrorModal from 'components/summary/TimeErrorModal/container';

export default styled(TimeErrorModal)`
  padding: ${gridSizes('S')};

  img {
    width: 100%;
  }
  .label {
    font-family: Roboto;
    font-size: ${gridSizes('M')};
    color: var(--grey900);
    margin: ${gridSizes('S')} auto;
  }
  button {
    margin-top: ${gridSizes('M')};
    font-family: Roboto;
    font-size: ${gridSizes('M')};
    font-weight: bold;

    line-height: 1.13;
  }

  ${media.lessThan('extraSmall')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    background: #fff;
  `};
`;
